import { useMutation } from '@vue/apollo-composable'
import gql from 'graphql-tag'
import { v4 } from 'uuid'
import { AddTreeGraphNode, CreateStep, GraphEntityType, Mutation } from '@/generated/graphql'

export type CreatedStepNode = { stepId: string; nodeId: string }

// Creates a bare step (no duration, tools or instructions) and adds it to the module graph.
export default function useCreateStepNode() {
  const mutation = useMutation<Mutation, { step: CreateStep; node: AddTreeGraphNode }>(gql`
    mutation createStepWithModuleGraphNode($step: CreateStep!, $node: AddTreeGraphNode!) {
      product {
        createStep(command: $step) {
          id
        }
        addNodeToModuleGraph(command: $node)
      }
    }
  `)

  const createStepNode = async (command: {
    productId: string
    moduleId: string
    name: string
    stepTypeId: string
  }): Promise<CreatedStepNode> => {
    const stepId = v4()
    const nodeId = v4()
    await mutation.mutate({
      step: {
        id: stepId,
        productId: command.productId,
        name: command.name,
        stepTypeId: command.stepTypeId,
        durationInSeconds: 0,
        toolIds: [],
      },
      node: {
        entityId: command.moduleId,
        node: {
          entityType: GraphEntityType.Step,
          entityId: stepId,
          parentId: undefined,
          id: nodeId,
        },
      },
    })
    return { stepId, nodeId }
  }

  return { createStepNode, loading: mutation.loading }
}
